/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RestoreCaseResult {
  Success = 0,
  Error = 1,
  CaseNotFound = 2,
  InvalidStatus = 3,
  NotCancelled = 4,
}
